"use client";

import Image from "next/image";
import { StepsDisplay, oekopunkteSteps } from "@/components/landing/StepsDisplay";
import { ButtonLink } from "@/components/ui";
import { routes } from "@/lib/routes";

export function OekopunkteSection() {
  return (
    <section id="okopunkte" className="section-lg px-4 bg-zinc-50">
      <div className="container-wide">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-primary mb-3">Ökopunkte</h2>
          <p className="text-zinc-600 max-w-2xl mx-auto">
            Schnell und unkompliziert Ökopunkte finden oder anbieten
          </p>
        </div>

        {/* Steps */}
        <div className="mb-12">
          <StepsDisplay steps={oekopunkteSteps} />
        </div>

        {/* Row 1: Text Left, Image Right - Ökopunkte kaufen */}
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-12">
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-bold text-primary mb-4">Ökopunkte kaufen</h3>
            <p className="text-zinc-600 mb-2">
              Als Vorhabenträger benötigen Sie zum Ausgleich für Eingriffe in die Natur und
              Landschaft Ökopunkte?
            </p>
            <p className="text-zinc-700 font-medium mb-6">
              Gerne nehmen wir Ihre Suchanfrage auf und senden Ihnen passende Angebote unserer
              Plattform per Email zu.
            </p>
            <div className="flex flex-wrap gap-3">
              <ButtonLink href={routes.schnellanfrage} variant="secondary">
                Ökopunkte kaufen
              </ButtonLink>
              <ButtonLink href={"/oekopunkte-kaufen-verkaufen"} variant="outline">
                Mehr erfahren
              </ButtonLink>
            </div>
          </div>
          <div className="flex-1 relative h-64 md:h-80 w-full rounded-lg overflow-hidden">
            <Image
              src="/content/heroes/oekopunkte-kaufen.jpg"
              alt="Ökopunkte kaufen"
              fill
              className="object-cover"
            />
          </div>
        </div>

        {/* Row 2: Image Left, Text Right - Ökopunkte verkaufen */}
        <div className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12">
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-bold text-primary mb-4">Ökopunkte verkaufen</h3>
            <p className="text-zinc-600 mb-2">
              Sie ergreifen oder planen auf Ihren Flächen Maßnahmen zur ökologischen Verbesserung
              und sind bzw. werden Eigentümer eines Ökokontos? Sie haben das Problem, dass Sie
              keinen Käufer finden?
            </p>
            <p className="text-zinc-700 font-medium mb-6">
              Gerne nehmen wir Ihr Angebot auf und senden Ihnen passende Kaufgesuche unserer
              Plattform per Email zu.
            </p>
            <div className="flex flex-wrap gap-3">
              <ButtonLink href={routes.schnellangebot} variant="secondary">
                Kompensation verkaufen
              </ButtonLink>
              <ButtonLink href={"/oekopunkte-kaufen-verkaufen"} variant="outline">
                Mehr erfahren
              </ButtonLink>
            </div>
          </div>
          <div className="flex-1 relative h-64 md:h-80 w-full rounded-lg overflow-hidden">
            <Image
              src="/content/heroes/oekopunkte-verkaufen.jpg"
              alt="Ökopunkte verkaufen"
              fill
              className="object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
